import {PLANET_HD_V1_ENABLED} from '../../../../../../config/featureFlags'
import {
  buildRemoteSensingSourcePayload,
  normalizeRemoteSensingSource,
} from './remoteSensingModel'

const getSelectionImageType = (selection = {}) => {
  const basis = selection?.params?.basis || selection?.basis
  const quality = selection?.params?.quality || selection?.quality
  if (quality === 'hd' && basis) {
    return basis === 'multiband' ? 'rgb_hd' : `${basis}_hd`
  }

  return selection.imageType || selection.image_type || selection?.params?.image_type || null
}

export const getExplicitRemoteSensingSource = (selection = {}) => {
  const source = normalizeRemoteSensingSource(
    selection.remoteSensingSource ||
    selection.remote_sensing_source ||
    selection.source ||
    {
      imageType: getSelectionImageType(selection),
      quality: selection?.params?.quality || selection.quality,
    }
  )

  return buildRemoteSensingSourcePayload(source)
}

export const withExplicitRemoteSensingSource = (
  payload,
  selection,
  {ambientType = null, enabled = PLANET_HD_V1_ENABLED} = {}
) => {
  if (!enabled) {
    return payload
  }

  const source = getExplicitRemoteSensingSource(selection)
  const acquisitionId = selection?.selectedAcquisitionId ||
    selection?.acquisition_id ||
    selection?.params?.acquisition_id ||
    null

  return {
    ...payload,
    product: source.product,
    layer: source.layer,
    image_type: source.image_type,
    remote_sensing_source: source,
    ...(acquisitionId ? {acquisition_id: acquisitionId} : {}),
    ...(ambientType ? {ambient_source_type: ambientType} : {}),
  }
}
